const HEADER_MOD = {
    "Can your analytics systems adapt to new innovation?": {
        header: "Innovation",
        negCopy:"Now is the time to invest in new analytics for your business and focus resources toward the next growth opportunity.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/paas/pt-ba-analytics-cloud-on-premises/index.html",
        negLinkTxt:"Take a quick tour of Oracle Analytics",
    },
    
    "How would you describe your enterprise financial analytics?": {
        header: "Enterprise Financial Analytics",
        negCopy:"Oracle analytics delivers a harmonized single source for all enterprise financial analytics",
        negLink: [
            'https://www.oracle.com/business-analytics/',
            'https://www.oracle.com/customers/western-digital.html'
        ],
        negLinkTxt: [
            'Learn more details here',
            'Enterprise Analytics at Western Digital'
        ],
    },     
    "Which best describes your risk analysis processes?": {
        header: "Risk Management",
        negCopy:"Integrate risk management monitoring and anaytics into your culture and business processes.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-erp/index.html",
        negLinkTxt:"See more in Fusion ERP Analytics",
    },
    "What is your company’s approach to digital transformation?": {
        header: "Digital Transformation",
        negCopy:"Modernize corporate cloud strategy with Oracle Analytics Cloud platform",
        negLink: [
            'https://blogs.oracle.com/analytics/financial-analytics-for-the-modern-cfo',
            'https://www.oracle.com/news/announcement/blog/oracle-accenture-ceo-summit-040121.html'
        ],
        negLinkTxt:[
            'Digital Transformation for the Modern CFO',
            'Pandemic has compressed Digital Transformation',
        ],
    },
    "Do you leverage Machine Learning (ML) in finance?": {
        header: "Machine Learning",
        negCopy:"Learn how Finance can benefit from machine learning (ML) for everyone",
        negLink:"https://blogs.oracle.com/analytics/how-to-get-started-with-machine-learning-and-ai-in-finance-v2",
        negLinkTxt:"Get started with Machine Learning in finance",
    },
    "Beyond standard ERP reports, what KPI's do you track?": {
        header: "Monitor Business Performance",
        negCopy:"Oracle analytics provides detailed KPIs with machine learning & natural language enrichment out of the box.",
        negLink:"https://www.oracle.com/business-analytics/fusion-analytics.html",
        negLinkTxt:"Learn more about business performance",
    },

    "How do you measure customer and product profitability today?": {
        header: "Profitability",
        negCopy:"Analyze performance and control costs with Oracle Analytics. Maximize profitability for each product or customer.",
        negLink: [
            'https://www.oracle.com/performance-management/profitability-cost-management/',
            'https://www.oracle.com/a/ocom/docs/applications/erp/oracle-fusion-erp-ebook.pdf'
        ],
        negLinkTxt: [
            'Business led modeling with profitability and cost management',
            'Fusion ERP Analytics eBook'
        ],
    },
    "Do you perform scenario modeling and predictive analysis?": {
        header: "Scenaro Modeling",
        negCopy:"Oracle Essbase in the cloud is the perfect tool for business scenaro modeling. See it here...",
        negLink: [
            'https://cloudmarketplace.oracle.com/marketplace/en_US/listing/67812026',
            'https://video.oracle.com/detail/video/6226330611001/introducing-oracle-essbase-in-the-cloud?autoStart=true&page=17&q=Oracle'
        ],
        negLinkTxt: [
            'Learn how to get started',
            'See the Essbase overview video…'
        ],
    },
    "What level of forecasting do you have today?": {
        header: "Forecasting",
        negCopy:"Oracle provides streamlined financial and predictive analytics.",
        negLink: [
            'https://www.oracle.com/performance-management/planning/ ',
            'https://www.oracle.com/webfolder/s/quicktours/paas/pt-ba-analytics-cloud-on-premises/index.html?source=:so:tw:or:awr:ana:::&SC=:so:tw:or:awr:ana:::&pcode='
        ],
        negLinkTxt: [
            'Learn more about planning, budgeting, and forecasting',
            'Quick overview of Oracle Analytics'
        ],
    },
    "How do you do Actual, Budget, Forecast variance analysis?": {
        header: "Variance / Management Reporting",
        negCopy:"Oracle can provide Embedded enterprise financial variance analytics, or let you customize your own.",
        negLink: [
            'https://blogs.oracle.com/analytics/the-four-types-of-reporting-in-finance',
            'https://blogs.oracle.com/analytics/bolthouse-farms-cuts-prep-time-for-management-reporting-from-4-hours-to-22-minutes-part-1'
        ],
        negLinkTxt: [
            'Four types of Reporting for Finance',
            'Analytics Success at Bolthouse Farms'
        ],
    },

    "What is your process for adding new data sources?": {
        header: "Onboarding New Data",
        negCopy:"Adding new data sources for analytics is fast and optimized, with both data flows and data preparation.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/paas/pt-ba-start-oracle-analytics-journey/index.html",
        negLinkTxt:"Learn how to easily bring your data into Oracle Analytics",
    },
    "How would you describe your data preparation process?": {
        header: "Data Preparation",
        negCopy:"Move to Enterprise-wide data management that’s agile, bi-directional, bottom-up and crowdsourced.",
        negLink:"https://www.youtube.com/watch?v=YPE2PztRt7I",
        negLinkTxt:"Oracle Analytics Data Preparation webcast",
    },

    "At what level of reporting is your revenue analysis today?": {
        header: "Revenue Analysis",
        negCopy:"Oracle Fusion ERP Analytics delivers in depth KPIs for revenue analysis. See our product tour.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-erp/index.html",
        negLinkTxt:"Oracle Fusion ERP Analytics Product Tour",
    },
    "How detailed is your cash flow or working capital analysis?": {
        header: "Cash Flow & Working Capital",
        negCopy:"Improve cash management with connected, standardized, predictive and trend analytics.",
        negLink: [
            'https://blogs.oracle.com/analytics/master-order-to-cash-with-oracle-analytics',
            'https://www.oracle.com/webfolder/s/quicktours/paas/pt-ba-start-oracle-analytics-journey/index.html'
        ],
        negLinkTxt: [
            'Master Order-to-Cash with Oracle Analytics',
            'Fusion ERP Analytics Details'
        ],
    },
    "At what level of reporting is your cost analysis today?": {
        header: "Cost Analysis",
        negCopy:"Oracle Fusion ERP Analytics covers costing and payables analytics in depth.",
        negLink: [
            'https://blogs.oracle.com/analytics/financial-analytics-for-the-modern-cfo',
            'https://www.oracle.com/business-analytics/fusion-analytics.html?bcid=6162518872001'
        ],
        negLinkTxt: [
            'Analytics for the Modern CFO',
            'Fusion ERP Analytics Demo Video',
        ],
    },
    "How do you do trend and historical aging analytics today?": {
        header: "Trend Analytics",
        negCopy:"Historic aging and trending is part of our embedded analytics, see below for more",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-erp/index.html",
        negLinkTxt:"See more trend analytics",
    },
    "What level of spend analytics do you have today?": {
        header: "Spend Analytics",
        negCopy:"Control your costs with real time visibility of spend information and savings opportunities.",
        negLink: [
            'https://blogs.oracle.com/analytics/are-you-getting-the-most-clarity-out-of-your-spend-analysis',
            'https://www.oracle.com/webfolder/s/quicktours/erp/pt-erp-spend-analytics-increased-visibility/index.html'
        ],
        negLinkTxt: [
            'Gain clarity in your spend analytics',
            'Spend Analytics product tour'
        ],
    },
    
    "How does your analytics system extend your ERP reporting?": {
        header: "ERP Analytics",
        negCopy:"Maximize your ERP with embedded KPIs with trending and forecasting analytics.",
        negLink:"https://blogs.oracle.com/analytics/tomorrows-cfo-succeeds-today-with-analytics",
        negLinkTxt:"Tomorrow's CFOs succeed with analytics",
    },
    "How do you perform end-to-end supply chain analysis?": {
        header: "Supply Chain Analytics",
        negCopy:"Automate the supply chain process with continuous evaluation and active analytic reporting.",
        negLink: [
            'https://www.oracle.com/webfolder/s/quicktours/erp/pt-erp-spend-analytics-increased-visibility/index.html',
            'https://blogs.oracle.com/analytics/master-order-to-cash-with-oracle-analytics',
        ],
        negLinkTxt: [
            'Quick overview of Supply Chain and Spend',
            'Mastering Order to Cash ',
        ],
    },
    "Can you combine Financial and HR data for analysis?": {
        header: "Human Capital Analytics",
        negCopy:'Oracle helps you leverage Financial and Human Capital data analytics together',
        negLink:[
            "https://www.youtube.com/watch?v=NRdVRMQMigY",
            'https://www.oracle.com/business-analytics/fusion-analytics.html?bcid=6188931785001'
        ],
        negLinkTxt:[
            "Win by bringing Finance and HR data together ",
            'HCM Analytics Overview Video'
        ],
    },
    
}
export default HEADER_MOD;